export default __webpack_public_path__ + "static/media/metamask-logo.894f5d1c.svg";